import React from 'react'
import type { Icon } from 'shared/utils'

const Nitrate = (props: Icon) => {
    const { color = 'black', size = 24, className = 'nitrate' } = props
    return (
        <svg fill={color} width={size} height={size} className={className}>
            <path
                d="M18.533 13.7H18.5a3.14 3.14 0 0 0-2.633 1.433L12.7 13.967V13.8c0-1.4-1.133-2.533-2.533-2.533-.167 0-.334 0-.467.033L8 7.6c.767-.567 1.233-1.5 1.233-2.533C9.267 3.4 7.833 2 6.167 2 4.433 2 3 3.4 3 5.1c0 1.733 1.4 3.067 3.067 3.1.266 0 .5-.033.733-.1l1.7 3.7c-.533.533-.9 1.233-.9 2 0 .567.2 1.033.467 1.433L6.5 16.9a2.55 2.55 0 0 0-1-.2 2.549 2.549 0 0 0-2.467 2.567c0 1.433 1.134 2.5 2.5 2.533 1.4 0 2.534-1.133 2.534-2.533 0-.567-.2-1.1-.534-1.534l1.534-1.666c.333.2.733.266 1.1.266.9 0 1.666-.466 2.133-1.166l3.1 1.1c-.033.166-.033.333-.033.5 0 1.666 1.4 3.066 3.066 3.1 1.7 0 3.1-1.4 3.1-3.1.067-1.634-1.333-3.034-3-3.067"
                fillRule="evenodd"
            />
        </svg>
    )
}

export { Nitrate }
